export default __webpack_public_path__ + "static/media/phone_black.23237439.svg";